import { render, staticRenderFns } from "./DialogoConfirmacao.vue?vue&type=template&id=f9acbb36"
import script from "./DialogoConfirmacao.vue?vue&type=script&lang=js"
export * from "./DialogoConfirmacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports